import { Checkbox, Divider } from "@material-ui/core";
import MuiContainer from "@material-ui/core/Container";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

// const sectors = JSON.parse(localStorage.getItem("@prit-web/sectors"));

export const Container = withStyles({
	root: {
		width: "480px",
		backgroundColor: "#ffffff",
	},
})(MuiContainer);

export const DividerCustom = withStyles({
	root: {
		backgroundColor: "#eee",
	},
})(Divider);

export const CheckboxColor = withStyles({
	root: {
		color: "#ffffff",
		"&$checked": {
			color: "#450067",
		},
	},
	checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default makeStyles((theme) => ({
	container: {
		display: "table",
		width: "100%",
	},
	nameList: { 
		marginLeft: "12px",
		fontFamily: "CircularStd",
		fontSize: "16px",
		fontWeight: 700,
		fontStretch: "normal",
		fontStyle: "normal",
		letterSpacing: "-0.47px",
		color: "rgba(0,0,0,0.65)",
		textAlign: "left",
		wordBreak: "break-word",
	},
	price: {
		display: "table-cell",
		maxHeight: "40px",
		fontFamily: "CircularStd",
		fontSize: "14px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		letterSpacing: "-0.47px",
		color: "rgba(0,0,0,0.65)",
		textAlign: "right",
		whiteSpace: "nowrap",
	},

	listCategoriesArea: {
		height: "80%",
		width: "100%",
		display: "flex",
	},

	listCategories: {
		paddingBottom: "55px",
		height: "fit-content",
		overflowX: "auto",
		"&::-webkit-scrollbar": {
			width: 0,
		},
	},

	selectedCategory: {
		width: "max-content",
		marginBottom: "10px",
		fontSize: "14px",
		fontWeight: 300,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.33,
		letterSpacing: -0.4,
		color: "#630094",
		borderBottom: " none",
		display: "inline-flex",
	},

	RectangleImage: {
		width: "100%",
		height: "70%",
		maxHeight: "80px",
		maxWidth: "100px",
		borderRadius: "20% 20% 0 0",
	},

	selectedCategoryRectangle: {
		height: "28px",
		backgroundColor: "rgb(57 55 98 / 3%)",
		display: "inline-block",
		margin: "0 4px 7px 0",
		borderRadius: "14px",
	},

	nameCategorieSelection: {
		fontSize: "11px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal,",
		lineHeight: "11px",
		letterSpacing: "-0.16px",
		textAlign: "center",
		color: "#474747",
	},

	scrollSelectedArea: {
		display: "flex",
		overflowX: "auto",
		"&::-webkit-scrollbar": {
			width: 0,
		},
	},

	selectedCategoryDelete: {
		width: "2.8em",
		margin: "-25px -8px",
		padding: "15px",
	},

	nameSector: {
		height: "21px",
		paddingBottom: 50,
		fontFamily: "CircularStd",
		fontSize: "15px",
		margin: "13px",
		fontWeight: 500,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "3.33",
		letterSpacing: "-0.5px",
		color: " #474747",
	},

	root: {
		padding: "2px 4px",
		display: "flex",
		alignItems: "center",
		height: " 36px",
		borderRadius: " 14px",
		boxShadow: "none",
		backgroundColor: "rgba(57, 55, 98, 0.04)",
	},

	inputSearch: {
		width: 335,
		marginLeft: theme.spacing(1),
		flex: 1,
	},

	countSelected: {
		width: "20px",
		height: "20px",
		margin: "12px 0 12px 0",
		padding: "0 2px 2px 2px",
		borderRadius: "5px",
		textAlign: "center",
		color: "#fff",
		backgroundColor: " #630094",
	},

	table: {
		minWidth: "100%",
	},

	tableFooter: {
		paddingTop: "7px",
		marginBottom: "0px",
		minWidth: "480px",
	},
	footer: {
		alignItems: "center",
		width: "20px",
		height: "20px",
		display: "flex",
		margin: "12px 0 12px 0",
		borderRadius: "5px",
		backgroundColor: " #630094",
	},

	nameCountServices: {
		width: "122px",
		height: "32px",
		margin: " 6px 35px 6px 8px",
		fontSize: "14px",
		fontWeight: " 300",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: 1.14,
		letterSpacing: "-0.47px",
		color: " #474747",
		padding: "1px",
		borderBottom: " none",
		display: "flex",
		alignItems: "center",
	},

	radioBtn: {
		height: "50%",
		margin: "0 5px",
		padding: "0 0 7px",
		borderRadius: "14px",
		transitions: "all 2s ease",
		width: "50%",
		boder: "3px solid transparent",
		display: "inline-block",
		position: "relative",
		textAlign: "center",
		boxShadow: " 0 0 3px #c3c3c367",
		cursor: "pointer",
	},

	colorClickBtn: {
		backgroundColor: "rgba(99, 0, 148, 0.8)",
		position: "absolute",
		borderRadius: "20% 20% 0 0",
		opacity: 0,
	},

	costumRadio: {
		display: "none",
	},

	clickList: {
		color: "#630094",
		opacity: 0,
		position: "absolute",
		top: "20px",
		borderRadius: "20% 20% 0 0",
	},

	centerDiv: { 
		display: "flex", 
		justifyContent: "space-between", 
		alignItems: "center" 
	},

	selectServicesLabel: { 
		fontSize: "18px", 
		fontWeight: "bold", 
		textAlign: "center", 
		flex: "1" 
	},

	footerAlign: { 
		display: "flex", 
		justifyContent: "space-around", 
		marginBottom: "20px" 
	},

	noServicesAvailble: { 
		textAlign: "center", 
		margin: "55px" 
	},

	levelTitle: {
		fontWeight: "bold",
		color: "#474747",
		fontSize: "20px"
	},

	levelTileDiv: { 
		//display: "flex", 
		flexDirection: "column", 
		//height: "58px" 
		overflowY: "auto"
	},

	levelTileAlign: { 
		width: "100%",
		display: "flex", 
		flexDirection: "column",
		justifyContent: "space-between", 
		alignItems: "center",
	},

	containerService: {
		display: 'flex', 
		flexDirection: "column",
		borderBottom: "1px solid rgba(0, 0, 0, 0.1)"
	},

	durationPrice: {
		paddingRight: "5px",
	},

	boxSelectServices: {
		padding: 20, 
		borderTopLeftRadius: 30,
  		borderTopRightRadius: 30,
		boxShadow: '0px -4px 12px rgba(0, 0, 0, 0.2)', 
		height: '100vh',
		backgroundColor: '#fff',
	},
	
	noScrollBar: {
		'&::-webkit-scrollbar': {
		   display: 'none',
		 },
	},

	selectedServicesContainer: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		backgroundColor: "transparent",
		paddingTop: "20px",
		flexDirection: "column",
		alignItems: "center",
	},

	selectedServicesWrapper: {
		display: "flex", 
		flexDirection: 'column', 
		alignItems: "center", 
		gap: "5px",
		width: "100%",
		maxWidth: "400px",
	},

	selectedServicesScrollContainer: {
		width: "100%",
		minHeight: "40px",
		borderRadius: "8px",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		position: "relative",
		padding: "4px 8px",
		overflow: "auto",
		scrollbarWidth: "none",
		msOverflowStyle: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
	},

	selectedServicesText: {
		backgroundColor: "#fff",
		padding: "2px 4px",
		borderRadius: "12px",
		border: "1px solid #222",
		whiteSpace: "nowrap",
		minWidth: "fit-content",
		width: "max-content",
		display: "inline-block"
	},

	selectedServicesCounter: {
		minWidth: "240px",
		height: "20px",
		borderRadius: "8px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
		top: 12,
		left: "50%",
		transform: "translateX(-50%)",
		backgroundColor: "#FDFCF8",
	},

	selectedServicesCounterText: {
		fontSize: "14px"
	},

	containerButtonsServices: {
		display: "flex", 
		alignItem: "center", 
		justifyContent: "center", 
		width: "100%",
	},

	buttonSelectServices: {
		backgroundColor: "transparent", 
		cursor: "unset",
		margin: "16px",
		color: "#222",
		height: 44,
		// em telas estreitas a fonte diminui para o texto não quebrar
		fontSize: "clamp(10px, 3.3vw, 15px)",
		whiteSpace: "nowrap",
		paddingLeft: 8,
		paddingRight: 8,
		display: "flex",
		width: "100%",
		borderRadius: "25.5px",
		maxWidth: "400px",
		flex: 1,
		border: "1px solid #222",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: "transparent"
		}
	}
}));

export const Services = withStyles({});
